import React, { useEffect, useMemo } from 'react'
import { nbPerPageLabel } from '../constants/ReferencialConstants'
import PropTypes from 'prop-types'
import useSessionStorage from 'utils/customHook/useSessionStorage'
import { filterAllCharacters } from 'utils/StringUtil'
import FiltersPanel from '../../administration/components/filters/FiltersPanel'
import { CardTable } from 'components/datatable/NewTable'
import { Stack } from '@mui/material'

const SearchTable = ({
    sessionKey = 'searchTable',
    title = '',
    data = [],
    setExportData = () => {},
    headers = [],
    headersFilter = headers,
    customHeaders = {},
    onClick = () => {},
    jobSync = undefined,
    margin = 1,
}) => {
    const [searchValue, setSearchValue] = useSessionStorage(`referencial_${sessionKey}`, '')

    const filteredData = useMemo(() => filterAllCharacters(data, headersFilter, searchValue), [data, searchValue])

    useEffect(() => {
        setExportData(filteredData)
    }, [filteredData])

    return (
        <Stack spacing={1} margin={margin} direction='column'>
            <FiltersPanel
                defaultFilter={{ searchValue }}
                onValidate={filter => setSearchValue(filter.searchValue)}
                jobSync={jobSync}
                color={'bannerColor'}
            />
            <CardTable
                color={'bannerColor'}
                title={title}
                rows={filteredData}
                headers={headers}
                headersLabel={customHeaders}
                onClickRow={onClick}
                rowsPerPageOptions={nbPerPageLabel}
            />
        </Stack>
    )
}

SearchTable.propTypes = {
    sessionKey: PropTypes.string,
    title: PropTypes.string,
    data: PropTypes.array,
    setExportData: PropTypes.func,
    color: PropTypes.string,
    headers: PropTypes.arrayOf(PropTypes.string),
    headersFilter: PropTypes.arrayOf(PropTypes.string),
    customHeaders: PropTypes.object,
    customWidthHeaders: PropTypes.object,
    onClick: PropTypes.func,
    jobSync: PropTypes.element,
    margin: PropTypes.number,
}

export default SearchTable
